


















import { Component, Prop, Vue } from 'vue-property-decorator';
import DropDownOption from './DropDownOption.vue';
import { AnswerType } from  '@/author/components/Quiz/AnswerTypes';
import { KNOWLEDGE_CHECK_EVENTS } from '@/author/constants';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue'

@Component
export default class DropDown extends Vue {
  @Prop() blankText!: string;
  @Prop() title!: string;
  @Prop() question!: string;
  @Prop() rightFeedback!: string;
  @Prop() neutralFeedback!: string;
  @Prop() wrongFeedback!: string;
  @Prop() linkHref!: string;
  @Prop() linkText!: string;
  linkTextMarkup = '{link}';
  submited: Boolean = false;
  options!: DropDownOption[];
  chosen: DropDownOption | null = null;

  created(){
    KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.MOUNTED);
  }

  mounted() {
    this.options = this.$children as DropDownOption[];
    KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.CLEAR_OPTIONS, this.resetOption)
  }
  beforeDestroy(){
    KnowledgeCheckEvents.$off([KNOWLEDGE_CHECK_EVENTS.CLEAR_OPTIONS])
  }
  choose(chosenId: string) {
    if (chosenId === 'blank') this.chosen = null;
    else {
      this.options.map(dr => {
        if ((dr as any)._uid == chosenId) this.chosen = dr;
      });
    }
  }

  get getChosen() {
    return this.chosen;
  }

  get imageSrc(): string {
    if (this.isRight) return require('@/assets/feedback-correct.png');
    if (this.isWrong) return require('@/assets/feedback-wrong.png');
    return require('@/assets/feedback-neutral.png');
  }

  get isRight(): boolean {
    return this.chosen ? this.chosen.answerType === AnswerType.right : false;
  }

  get isWrong(): boolean {
    return this.chosen ? this.chosen.answerType === AnswerType.wrong : false;
  }

  get isNeutral(): boolean {
    return this.chosen ? this.chosen.answerType === AnswerType.neutral : false;
  }

  get preLinkFeedback(): string {
    let startPos = this.feedback().indexOf(this.linkTextMarkup);
    return startPos === -1
      ? this.feedback()
      : this.feedback().substring(0, startPos);
  }

  get postLinkFeedback(): string {
    let linkText = this.linkTextMarkup;
    let startPos = this.feedback().indexOf(linkText);
    return startPos === -1
      ? ''
      : this.feedback().substring(
          startPos + linkText.length,
          this.feedback().length
        );
  }

  private feedback(): string {
    if (!this.chosen) return '';
    let answerFeedback = '';
    switch (this.chosen.answerType) {
      case AnswerType.right:
        answerFeedback = this.rightFeedback;
        break;
      case AnswerType.neutral:
        answerFeedback = this.neutralFeedback;
        break;
      case AnswerType.wrong:
        answerFeedback = this.wrongFeedback;
        break;
    }

    return answerFeedback;
  }

  resetOption(){
    this.submited = false
  }

  onChange(event: any) {
    this.choose(event.target.value);
    KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED);
  }

  markAsSubmited() {
    this.submited = true;
  }
}
